/**
 * Shim for @angular/cdk/portal that provides a PortalInjector polyfill.
 *
 * PortalInjector was removed from @angular/cdk/portal in Angular CDK v21+.
 * merceros-ui-components still imports it, so this shim re-exports everything
 * from the real module and adds a compatible PortalInjector implementation
 * using Injector.create().
 *
 * Wired via webpack resolve.alias in webpack.sass-color-inject.js so that
 * node_modules never need to be patched.
 */

// Re-export everything from the real @angular/cdk/portal
export * from '@angular/cdk/portal/real';

// Provide a PortalInjector compatibility class
import { Injector } from '@angular/core';

export class PortalInjector {
    constructor(_parentInjector, _customTokens) {
        const providers = [];
        if (_customTokens) {
            _customTokens.forEach((value, key) => {
                providers.push({ provide: key, useValue: value });
            });
        }
        this._injector = Injector.create({
            providers: providers,
            parent: _parentInjector
        });
    }

    get(token, notFoundValue) {
        return this._injector.get(token, notFoundValue);
    }
}
